import { useScrollReveal } from "@/hooks/useScrollReveal";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

const GallerySection = () => {

  const { data: projects = [] } = useQuery({
    queryKey: ["posts", "gallery-home"],
    queryFn: async () => {
      const { data } = await supabase
        .from("posts")
        .select("*, categories(name)")
        .eq("section", "gallery")
        .order("sort_order")
        .limit(6)
        .returns<Array<{
          id: string;
          title: string;
          image_url: string | null;
          categories: { name: string } | null;
        }>>();
      return data ?? [];
    },
  });

  const ref = useScrollReveal([projects]);

  return (
    <section id="gallery" className="py-20 bg-secondary/50" ref={ref}>
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 animate-on-scroll">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            הפרויקטים <span className="text-primary">שלנו</span>
          </h2>
          <p className="text-muted-foreground text-lg">מבחר עבודות נבחרות שביצענו לאורך השנים</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {projects.map((project, i) => {
            const category = project.categories;
            return (
              <div
                key={project.id}
                className="animate-on-scroll group relative aspect-[4/3] rounded-xl overflow-hidden bg-dark cursor-pointer hover-lift"
                style={{ transitionDelay: `${i * 100}ms` }}
              >
                {project.image_url ? (
                  <img
                    src={project.image_url}
                    alt={`${project.title}${category?.name ? ` – ${category.name}` : ""}`}
                    loading="lazy"
                    decoding="async"
                    width={800}
                    height={600}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                ) : (
                  <div className="absolute inset-0 flex items-center justify-center">
                    <span className="text-dark-foreground/30 text-6xl font-bold">{i + 1}</span>
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-dark/90 via-dark/40 to-transparent" />
                <div className="absolute bottom-0 right-0 left-0 p-4 transform transition-all duration-300 group-hover:translate-y-0 translate-y-2 group-hover:pb-6">
                  <span className="text-xs text-primary font-medium mb-1 block">
                    {category?.name || ""}
                  </span>
                  <h3 className="text-dark-foreground font-bold">{project.title}</h3>
                </div>
                <div className="absolute inset-0 bg-primary/0 group-hover:bg-primary/10 transition-colors duration-300" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
